module.exports = __webpack_public_path__ + "img/tintuc2.0e1b6068.png";